<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-input v-model="showRow[field]"
                        v-if="lv_editable"

                        :type="type"
                        :recommend="recommend"
                        :recommend-lov="recommendLov"
                        :recommend-filter="recommendFilter"
                        :color="color"
                        :size="size"
                        :shape="shape"
                        :dashed="dashed"
                        :prefixIcon="prefixIcon"
                        :suffixIcon="suffixIcon"
                        :placeholder="placeholder"
                        :disabled="disabled"
                        :readonly="readonly"
                        :regexp="regexp"
                        :width="inputWidth"
                        :input-type="inputType"
                        :focus-on-hover="focusOnHover"
                        :required="lv_required"
                        :rules="rules"
						:replacement="replacement"
                        :validate-on-init="validateOnInit"

                        @change="e=>$emit('change',{row:showRow,value:e,field})"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="null"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LinkInput from "../../input/link-input";
    import LvScopeSlot from "../../render/lv-scope-slot";
    import PlTooltipText from "../../tooltip/pl-tooltip-text";

    export default {
        name: "link-table-column-input-item",
        components: {PlTooltipText, LvScopeSlot, LinkInput},
        mixins: [ColumnItemMixin],
        props: {
            dataType: {required: false, type: String},      //数据显示类型
            type: {type: String,},
            recommend: {type: Array},                                                   //推荐下拉选项
            recommendLov: {type: String},                                               //推荐值列表类型
            recommendFilter: {type: Function},                                          //推荐输入自定义筛选函数
            color: {type: String,},
            size: {type: String,},
            shape: {type: String,},
            dashed: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String},
            placeholder: {type: String, default: '点击输入内容'},
            disabled: {type: Boolean},
            readonly: {type: Boolean},
            regexp: {type: RegExp},
            inputWidth: {type: Number | String,},
            inputType: {type: String},
            focusOnHover: {type: Boolean},
			replacement: {type: String, default: ''},                                   // 设置替换文本或生成替换文本的函数。
        },
    }
</script>
